import { render, staticRenderFns } from "./email-delivery-notes.vue?vue&type=template&id=71980b65&"
import script from "./email-delivery-notes.vue?vue&type=script&lang=ts&"
export * from "./email-delivery-notes.vue?vue&type=script&lang=ts&"
import style0 from "./email-delivery-notes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports